module.exports = __webpack_public_path__ + "static/flatart_ai_studio_header_03-c49b854a1be0ba42bc624898737ff84c.webp";